export const constants = {
  GET_DYNAMIC_MESSAGE_ENDPOINT: '/api/dyn-msg-service/v1/message',
  CONTENT_TYPE_JSON: 'application/json',
};
